// src/utils/models.js
//
// Shared vocabulary and helpers for the admin model panels
// (ModelConfigPanel.vue, ModelDiffPanel.vue). Kept out of the components so the
// editor and the compare view cannot drift on what a valid role or a version
// number is.

// Fallbacks only. The live lists come from GET /model/options, which derives
// them from the backend dispatch table (chat_models/utils.py: supported_families)
// and the router's VALID_MODEL_GROUPS. These copies are used when that route is
// unavailable, e.g. against a backend older than the one that shipped it, so the
// dropdowns still populate instead of rendering empty. See modelApi.loadOptions.
//
// That endpoint did not exist when this comment was first written, so for a
// while these were not fallbacks at all -- they were the only lists, and they
// drifted: spark-* was missing from the dropdown for as long as spark existed.
// Keep them in step, but the derived endpoint is the source of truth now.
export const FALLBACK_FAMILIES = [
  "openai",
  "google",
  "ollama-qwen",
  "ollama-llama",
  "ollama-gptoss",
  "ollama-gemma",
  "ollama-mistral",
  "mlx-qwen",
  "mlx-llama",
  "mlx-gemma",
  "spark-qwen",
];

// Valid model roles (routers/model.py: VALID_MODEL_GROUPS). Fallback, as above.
export const FALLBACK_MODEL_GROUPS = [
  "core",
  "end_detection",
  "self_help",
  "tgrow_summary",
  "soap_summary",
  "birp_summary",
  "sms_message",
  "email_message",
];

// Parse the trailing _version_NNN off a model name -> integer (0 if absent).
export function versionNum(name) {
  const m = /_version_(\d{3})$/.exec(name || "");
  return m ? parseInt(m[1], 10) : 0;
}

export function pad3(n) {
  return String(n).padStart(3, "0");
}

// Validate a JSON string. error is a human-readable lint message (empty when
// valid). A literal newline inside a string is invalid JSON, which is what
// forces the admin to use "\n".
export function lintJson(text) {
  if (!text || !text.trim()) return { value: null, error: "Cannot be empty." };
  try {
    return { value: JSON.parse(text), error: "" };
  } catch (e) {
    return { value: null, error: String(e.message || e) };
  }
}
